import React from 'react'

interface TerminalWindowProps {
  title?: string
  children: React.ReactNode
  className?: string
}

export const TerminalWindow: React.FC<TerminalWindowProps> = ({
  title = 'terminal',
  children,
  className = '',
}) => {
  return (
    <>
      <style>{`
        .terminal-window {
          background-color: var(--terminal-bg);
          border: 1px solid var(--terminal-border);
          border-radius: 8px;
          overflow: hidden;
          font-family: 'JetBrains Mono', 'Courier New', monospace;
        }
        .terminal-header {
          background-color: var(--terminal-header);
          height: 32px;
          display: flex;
          align-items: center;
          padding: 0 12px;
          border-bottom: 1px solid var(--terminal-border);
          position: relative;
        }
        .terminal-dots {
          display: flex;
          gap: 6px;
          align-items: center;
          z-index: 1;
        }
        .terminal-dot {
          width: 12px;
          height: 12px;
          border-radius: 50%;
          flex-shrink: 0;
        }
        .terminal-dot-red    { background-color: #ff5f57; }
        .terminal-dot-yellow { background-color: #febc2e; }
        .terminal-dot-green  { background-color: #28c840; }
        .terminal-title-text {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          font-size: 0.75rem;
          color: var(--text-muted, #555);
          white-space: nowrap;
          pointer-events: none;
        }
        .terminal-content {
          padding: 16px;
          overflow-x: auto;
        }
      `}</style>
      <div className={`terminal-window ${className}`}>
        <div className="terminal-header">
          <div className="terminal-dots">
            <span className="terminal-dot terminal-dot-red" />
            <span className="terminal-dot terminal-dot-yellow" />
            <span className="terminal-dot terminal-dot-green" />
          </div>
          <span className="terminal-title-text">{title}</span>
        </div>
        <div className="terminal-content">{children}</div>
      </div>
    </>
  )
}
